export const enum GOAL_STATUS {
  NONE = 'none',
  CURRENT = 'current',
  ACHIEVED = 'achieved',
}
